var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartMoving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70508 21.3789L7.37061 20.0463C9.85388 19.337 12.5124 20.2963 13.9706 22.4279L30.9334 47.2241C32.3916 49.3556 35.0501 50.315 37.5334 49.6057L67.1997 41.1322",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5406 57.0204C51.6247 60.816 49.4267 64.7717 45.6312 65.8558C41.8357 66.9399 37.88 64.7418 36.7959 60.9463C35.7118 57.1508 37.9098 53.1951 41.7053 52.111C45.5008 51.0269 49.4565 53.2249 50.5406 57.0204Z",
    stroke: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 26.8281L62.028 18.1977L64.9672 28.7988C65.8526 31.9921 63.9817 35.2984 60.7884 36.1838L41.2246 41.608C38.0313 42.4934 34.725 40.6224 33.8396 37.4292L30.9004 26.8281Z",
    fill: "#F2CA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3243 16.2747L38.2803 8.90234L46.4717 6.63119L48.5158 14.0035L43.7387 12.6817L40.3243 16.2747Z",
    fill: "#F2CA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0067 38.8944L41.2248 41.6066C38.0315 42.4919 34.7252 40.621 33.8398 37.4277L31.1277 27.6458L28.4156 17.8639C27.5302 14.6707 29.4011 11.3643 32.5944 10.479L35.004 9.81088L52.1582 5.05473C55.3515 4.16937 58.6578 6.04029 59.5432 9.23354L59.9841 10.824L62.7095 20.6537",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartMoving);
export default __webpack_public_path__ + "static/media/cartMoving.95cc922d1437f10131c4ea5f96712c63.svg";
export { ForwardRef as ReactComponent };